export const getJobsColumns = (columnsToHide) =>
  [
    {
      Header: 'Title',
      accessor: 'title',
      width: '320px',
      disableSortBy: true,
      lockPosition: 'left',
      pinned: 'left',
      suppressMovable: true,
    },
    {
      Header: 'Company',
      accessor: 'company',
      width: '200px',
      disableSortBy: true,
    },
    {
      Header: 'Location',
      accessor: 'location',
      width: '216px',
      disableSortBy: true,
    },
    {
      Header: 'Compensation',
      accessor: 'compensation',
      width: '200px',
      disableSortBy: true,
    },
    {
      Header: 'Source',
      accessor: 'source',
      width: '104px',
      disableSortBy: true,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: '96px',
      disableSortBy: true,
    },
    {
      Header: 'Visibility',
      accessor: 'visibility',
      width: '120px',
      disableSortBy: true,
    },
    {
      Header: 'Featured',
      accessor: 'featured',
      width: '120px',
      disableSortBy: true,
    },
    {
      Header: 'List & AI matches',
      accessor: 'list',
      width: '280px',
      disableSortBy: true,
    },
    {
      Header: 'Created by',
      accessor: 'createdBy',
      disableSortBy: true,
      width: '160px',
    },
    {
      Header: 'Created on',
      accessor: 'createdAt',
      width: '160px',
    },
    {
      Header: 'Applicants',
      accessor: 'applicants',
      disableSortBy: true,
      width: '96px',
    },
    {
      Header: 'Expiring',
      accessor: 'expirationDate',
      width: '112px',
    },
  ].filter((column) => !columnsToHide.has(column.accessor));
